import { useNavigate } from 'react-router-dom';
import { useCompanies, useMe } from '../api/hooks';
import { Hint, Row, Surface } from '../components/ui';
import { useT } from '../i18n';
import { useTopbar } from '../state/topbar';

export function More() {
  const t = useT();
  useTopbar(t('nav.more'));
  const navigate = useNavigate();
  const { data: me } = useMe();
  const { data: companies = [] } = useCompanies();

  const firms = companies.map((s) => s.shortName).join(', ') || 'Zatím žádná firma';
  const items: [string, string, string][] = [
    ['/asistent', 'AI asistent', 'Faktury, sklad, schůzky a přehledy větou, hlasem i z fotky'],
    ['/kalendar', 'Kalendář', 'Schůzky, výkupy a předání; připomenutí a odběr do iPhonu'],
    ['/ukoly', 'Úkoly mozku', 'Co má AI dělat sama: ranní přehled, hlídání reklam, sklad'],
    ['/reklamy', 'Reklamy', 'Meta Ads: útrata, objednávky z webů, ROAS, pauza a rozpočet'],
    ['/zakazky', 'Zakázky a opravy', 'Příjem zařízení, termíny, technik, protokol, faktura'],
    [
      '/velkoobchod',
      'Velkoobchod',
      'Nákupy od dodavatelů, co zbývá prodat, odběratelé a dělení zisku',
    ],
    [
      '/weby',
      'Weby',
      'Návštěvnost, zdroje, regiony, nákupy a zákazníci všech e-shopů včetně isupplychecker.com',
    ],
    ['/prehledy', 'Přehledy', 'Obrat, marže, cash flow, pohledávky, sklad – CSV/XLSX/PDF'],
    ['/vice/kontakty', 'Kontakty', 'Odběratelé a jejich historie'],
    ['/sklad/skener', 'Skener', 'IMEI / EAN kamerou nebo ručně, rychlý příjem, offline fronta'],
    ['/vice/firmy', 'Moje firmy', firms],
    ['/vice/sklady', 'Sklady', 'Sklady firmy a pozice v nich'],
    ['/vice/rady', 'Číselné řady', 'Formát a další číslo pro každý typ dokladu'],
    ['/vice/ucetni', 'Účetní', 'Přiznání k DPH, kontrolní a souhrnné hlášení, balíček pro účetní'],
    ['/vice/schvalovani', 'Schvalování', 'Doklady nad limit čekají na schválení'],
    [
      '/vice/automatizace',
      'Automatizace',
      'Pravidla KDYŽ → PAK: upomínky, upozornění, schválení, párování',
    ],
    ['/vice/notifikace', 'Notifikace', 'Co se stalo ve firmách, kde jsi členem'],
    ['/vice/import', 'Import', 'Partneři, produkty, kusy, zásoby a platby z CSV/XLSX'],
    ['/vice/pohoda', 'POHODA a ISDOC', 'Import dokladů z POHODY a přijatých faktur ISDOC'],
    ['/vice/nastaveni', 'Nastavení', 'Firmy, funkce, uživatelé a role, API klíče, návody'],
    ['/vice/navody', 'Návody', 'Co která funkce dělá, kde ji najdeš a jak na ni'],
    ['/vice/admin', 'Administrace', 'Stav systému, zálohy, fronty, chyby, uživatelé, retention'],
    ['/vice/o-aplikaci', 'O aplikaci', 'Co aplikace umí, přidání na plochu'],
  ];

  return (
    <>
      <Surface className="mt">
        {items.map(([path, title, sub]) => (
          <Row key={path} onClick={() => navigate(path)}>
            <div className="grow">
              <div className="l1">{title}</div>
              <div className="l2">{sub}</div>
            </div>
          </Row>
        ))}
      </Surface>
      <Surface className="mt">
        <Row onClick={() => navigate('/vice/ucet')}>
          <div className="grow">
            <div className="l1">{t('nav.account')}</div>
            <div className="l2">{me?.email ?? 'Heslo a odhlášení'}</div>
          </div>
        </Row>
      </Surface>
      <Hint>Data drží server, po přihlášení na jiném zařízení uvidíš totéž.</Hint>
    </>
  );
}
